import { FC, useEffect, useRef, CSSProperties } from 'react'
import Hammer from 'hammerjs'

type ModalLayerProps = {
  onTap: (hammerEvent: HammerInput, onTapArgs: any) => void
  onTapArgs?: any
  className?: string
  width?: string
  height?: string
  left?: number
  top?: number
  position?: 'relative' | 'absolute' | 'fixed'
  zIndex?: number
}

const ModalLayer: FC<ModalLayerProps> = ({
  onTap,
  onTapArgs = null,
  className = 'modal-background',
  width = '100%',
  height = '100%',
  left = 0,
  top = 0,
  position = 'relative',
  zIndex = 50,
}) => {
  const modalRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!modalRef.current) return

    const hammerManager = new Hammer.Manager(modalRef.current, {
      recognizers: [[Hammer.Tap]],
    })

    hammerManager.on('tap', hammerEvent => onTap(hammerEvent, onTapArgs))

    return () => {
      hammerManager.off('tap')
      hammerManager.destroy()
    }
  }, [onTap, onTapArgs])

  const modalStyle: CSSProperties = {
    position,
    width,
    height,
    left,
    top,
    zIndex,
  }

  return <div ref={modalRef} className={className} style={modalStyle}></div>
}

export default ModalLayer
